import React from 'react';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
//import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

import Axios from 'axios';
import moment from 'moment';

import { toISODateTime } from '@libs/NwMoment';
import { getBaseUrl } from '@libs/NwUtils';

import GlobalContextProvider from '@contexts';
import * as serviceWorker from '@/serviceWorker';
import 'core-js/stable';

// Polyfill per gestire gli errori di ResizeObserver
if (typeof window !== 'undefined') {
    const resizeObserverLoopErrRe = /^[^(ResizeObserver loop limit exceeded)]/;
    const resizeObserverLoopErr = 'ResizeObserver loop completed with undelivered notifications.';

    const originalError = window.console.error;
    window.console.error = (...args) => {
        if (args.length > 0 && typeof args[0] === 'string' && args[0].includes(resizeObserverLoopErr)) {
            // Ignora silenziosamente gli errori di ResizeObserver
            return;
        }
        originalError.apply(console, args);
    };

    // Gestisce anche gli errori non catturati
    window.addEventListener('error', (e) => {
        if (e.message && e.message.includes(resizeObserverLoopErr)) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    });
}

//set base configuration for Axios
Axios.defaults.baseURL = getBaseUrl();

//override standard behaviour of moment.toJSON
// to remove the local timezone when converting to JSON
moment.fn.toJSON = function () {
    return toISODateTime(this);
};

// ReactDOM.render(
// 	<GlobalContextProvider/>
// 	, document.getElementById('root'));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<GlobalContextProvider />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
